/**
 * @param {function} func
 * @param {function|undefined} [argGen]
 */
export const genericSWRFetcher = (func, argGen) => async (key) => {
  let args = [];
  if (argGen) {
    args = argGen(key);
  }

  const resp = await func(...args);
  if (resp.status === "ok") {
    return resp.data;
  }

  throw new Error(resp.message);
};

export const formatDateFromDatePicker = (dateObj) => {
  if (!dateObj) return null;
  return dateObj.format("YYYY-MM-DD");
};
